module.exports = __webpack_public_path__ + "img/estrella.7d33e9bb.svg";